const Tabs = function (args) {
	const that = this;

		this.init = function () {
				this.cacheDom();
				bindEvents();
		}

		this.cacheDom = function () {
			this.nav_item = document.querySelectorAll(args.nav_item);
			this.tab_pane = document.querySelectorAll(args.tab_pane);
		};

		function bindEvents() {
			for(let i=0; i<that.nav_item.length; i++){
				that.nav_item[i].addEventListener('click', function(){
					that.activate(undefined, this)
				});
			}
		}

		this.activate = function(num = undefined, clicked){
			let index;

			(num != undefined) ? index = num : index = [...that.nav_item].indexOf(clicked);

			for(let i=0; i<that.nav_item.length; i++){
				if(i !== index){
					that.nav_item[i].classList.remove('is-active');
					that.tab_pane[i].classList.remove('is-active');
				}else{
					that.nav_item[i].classList.add('is-active');
					that.tab_pane[i].classList.add('is-active');
				}
			}
		}
};

module.exports = Tabs;